// Use [style URL]/draft?optimize=true when testing out new styles
export const mapStyle =
  'mapbox://styles/geckorobotics/cll2qslw4000i01p82r36b0nu?optimize=true'
